module.exports = __webpack_public_path__ + "img/service_icon6-pressed.1dab4795.png";